import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { TypedMemo } from '../../../common/types';
import { SMLUpgradeFeature } from '../../config/music24PlanCapabilities';
import { planNameMessages } from '../../config/music24PlanNames';
import { SMLUpgradeBody } from './SMLUpgradeBody';
import { SMLUpgradeActions } from './SMLUpgradeActions';
import { featureCopy, upgradeMessages } from './upgradeMessages';
import { UpgradeOffer } from './useUpgradeOffer';
import styles from './SMLUpgradeSuccess.module.scss';

interface SMLUpgradeSuccessProps {
  feature: SMLUpgradeFeature;
  offer: UpgradeOffer;
  /** Closing returns the person to the exact view that was blocked. */
  onClose: () => void;
}

const SMLUpgradeSuccessComponent: React.FC<SMLUpgradeSuccessProps> = ({ feature, offer, onClose }) => {
  const intl = useIntl();
  const planName = intl.formatMessage(planNameMessages[offer.plan.tier]);

  const lede = `${intl.formatMessage(featureCopy[feature].valueTitle)} — ${intl.formatMessage(
    upgradeMessages.successBody
  )}`;

  return (
    <SMLUpgradeBody
      title={intl.formatMessage(upgradeMessages.successTitle, { plan: planName })}
      lede={lede}
      lead={
        <span className={styles.successMark}>
          <FontAwesomeIcon icon={faCheck} />
        </span>
      }
    >
      {offer.subscriptionExpiresAt !== null && (
        <span className={styles.renewPill}>
          {intl.formatMessage(upgradeMessages.successRenews, {
            price: offer.monthlyPrice,
            date: intl.formatDate(offer.subscriptionExpiresAt, { year: 'numeric', month: 'short', day: 'numeric' }),
          })}
        </span>
      )}

      <SMLUpgradeActions
        primaryLabel={intl.formatMessage(upgradeMessages.successBack)}
        onPrimary={onClose}
        fineprint={
          offer.email === undefined
            ? undefined
            : intl.formatMessage(upgradeMessages.successReceipt, { email: offer.email })
        }
      />
    </SMLUpgradeBody>
  );
};

export const SMLUpgradeSuccess = TypedMemo(SMLUpgradeSuccessComponent);
